import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericHttp } from '../interfaces';
import { AdvanceResult } from '../interfaces/advance-result.interface';

export class GenericHttpService<T> implements GenericHttp<T> {
  protected headers: HttpHeaders;

  constructor(
    protected httpClient: HttpClient,
    @Inject(String) protected baseUrl: string,
    @Inject(String) protected endpoint: string
  ) {
    this.headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json');
  }

  getAll(args?: {
    httpParams?: HttpParams;
    extra?: string;
  }): Observable<AdvanceResult<T[]>> {
    const { httpParams, extra } = Object(args);
    const url = `${this.baseUrl}/${this.endpoint}/${extra || ''}`;
    return this.httpClient.get<AdvanceResult<T[]>>(url, { params: httpParams });
  }

  getById(id: string): Observable<any> {
    return this.httpClient.get<T>(
      `${this.baseUrl}/${this.endpoint}/${id}`,
      {observe: 'response'}
    );
  }
  get(endpoint: string): Observable<any> {
    return this.httpClient.get<T>(
      `${this.baseUrl}/${this.endpoint}/${endpoint}`,
      {observe: 'response'}

    );
  }

  post(viewModel: Partial<T>, extra?: string): Observable<any> {
    return this.httpClient.post<T>(
      `${this.baseUrl}/${this.endpoint}/${extra || ''}`,
      viewModel,
      {
        observe: 'response',
        headers: this.headers
      }
    );
  }

  // --- New special post for binary files ---
  postBlob(viewModel: any, extra?: string, responseType: 'blob' | 'arraybuffer' = 'blob'): Observable<Blob> {
    const url = `${this.baseUrl}/${this.endpoint}/${extra || ''}`;
    return this.httpClient.post(url, viewModel, {
      headers: this.headers,
      observe: 'body',
      responseType: responseType as 'json', // TS quirk; cast to satisfy HttpClient typing
    }) as Observable<Blob>;
  }

  patch(id: string, viewModel: Partial<T>): Observable<T> {
    return this.httpClient.patch<T>(
      `${this.baseUrl}/${this.endpoint}/${id}`,
      viewModel,
      {
        headers: this.headers,
      }
    );
  }

  put(id: string, viewModel: Partial<T>): Observable<T> {
    return this.httpClient.put<T>(
      `${this.baseUrl}/${this.endpoint}/${id}`,
      viewModel,
      {
        headers: this.headers,
      }
    );
  }

  delete(id: string): Observable<T> {
    return this.httpClient.delete<T>(`${this.baseUrl}/${this.endpoint}/${id}`);
  }
}
